import axios from './index';

//  v1: deprecated
export const _getRoute = () => axios.get('public/v1/app/get-routes');

// v2
export const getRouteRequest = (filterObj = {}) => {
  const { issuerID, routeCategoryID, status } = filterObj;
  return axios.get(
    `v1/admins/routes/get/routes/-/${issuerID || '-'}/${
      routeCategoryID || '-'
    }/${status || '-'}/-`
  );
};

// v2 issuer
export const getIssuerRouteRequest = (filterObj = {}) => {
  const { status } = filterObj;
  return axios.get(`v1/issuer-staffs/routes/get/routes/-/${status || '-'}/-/-`);
};

//  v1: deprecated
export const _getRouteCategory = () =>
  axios.get(`public/v1/app/get-route-category`);

//  v1: deprecated
export const _createRoute = (reqObj) =>
  axios.post(`public/v1/app/create-route`, reqObj);

// v2
export const createRouteRequest = (payload) =>
  axios.post('v1/admins/routes/create/route', payload);

// v1: deprecated
export const _updateRoute = (reqObj) =>
  axios.put(`public/v1/app/update-route`, reqObj);

// v2
export const updateRouteRequest = (id, payload) =>
  axios.put(`v1/admins/routes/update/route/${id}`, payload);

// v1 : deprecated
export const _updateRouteStatus = (reqObj) =>
  axios.put(`public/v1/app/update-route-status`, reqObj);

// v2
export const updateRouteStatusRequest = (id, payload) =>
  axios.put(`v1/admins/routes/toggle/route/${id}/access-status`, payload);
